enum Shade {
  DARK = 'dark',
  LIGHT = 'light',
}

enum IconStyle {
  SOLID = 'solid',
  REGULAR = 'regular',
  BRANDS = 'brands',
}

enum IconNames {
  ALIGN_CENTER = 'align-center',
  ALIGN_LEFT = 'align-left',
  ALIGN_RIGHT = 'align-right',
  ANGLE_LEFT = 'angle-left',
  ANGLE_RIGHT = 'angle-right',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  BOLD = 'bold',
  BOLT = 'bolt',
  CALENDAR = 'calendar',
  CALENDAR_CHECK = 'calendar-check',
  CARET_DOWN = 'caret-down',
  CART_SHOPPING = 'cart-shopping',
  CHECK = 'check',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CIRCLE = 'circle',
  CIRCLE_CHECK = 'circle-check',
  CIRCLE_INFO = 'circle-info',
  CIRCLE_XMARK = 'circle-xmark',
  CLOCK = 'clock',
  CLOSE = 'close',
  CODE = 'code',
  CODE_SIMPLE = 'code-simple',
  COLON = 'colon',
  CREDIT_CARD = 'credit-card',
  DOWNLOAD = 'download',
  ELLIPSIS = 'ellipsis',
  ELLIPSIS_H = 'ellipsis-h',
  ENVELOPE = 'envelope',
  EXCLAMATION_CIRCLE = 'exclamation-circle',
  FACEBOOK_F = 'facebook-f',
  FILE_LINES = 'file-lines',
  FILE_TEXT = 'file-text',
  GOOGLE = 'google',
  GRID_HORIZONTAL = 'grid-horizontal',
  HIGHLIGHTER = 'highlighter',
  HOME = 'home',
  HOUSE = 'house',
  HOUSE_CHIMNEY = 'house-chimney',
  IMAGE = 'image',
  INSTAGRAM = 'instagram',
  ITALIC = 'italic',
  LINE = 'line',
  LINK = 'link',
  LIST_OL = 'list-ol',
  LIST_UL = 'list-ul',
  MAGNIFYING_GLASS = 'magnifying-glass',
  MINUS = 'minus',
  PEN_TO_SQUARE = 'pen-to-square',
  PLUS = 'plus',
  REDO = 'redo',
  ROTATE = 'rotate',
  SEARCH = 'search',
  SLIDERS = 'sliders',
  SORT = 'sort',
  SORT_DOWN = 'sort-down',
  SORT_UP = 'sort-up',
  SPINNER = 'spinner',
  SPINNER_THIRD = 'spinner-third',
  SQUARE = 'square',
  SQUARE_EXCLAMATION = 'square-exclamation',
  STRIKETHROUGH = 'strikethrough',
  SUBSCRIPT = 'subscript',
  SUPERSCRIPT = 'superscript',
  TABLE = 'table',
  TIKTOK = 'tiktok',
  TRASH_CAN = 'trash-can',
  TRIANGLE = 'triangle',
  TRIANGLE_EXCLAMATION = 'triangle-exclamation',
  TRUCK = 'truck',
  TRUCK_FAST = 'truck-fast',
  TWITTER = 'twitter',
  UNDERLINE = 'underline',
  UNDO = 'undo',
  USER = 'user',
  WEIXIN = 'weixin',
  WHATSAPP = 'whatsapp',
  XMARK = 'xmark',
  XMARK_LARGE = 'xmark-large',
  X_MARK = 'x-mark',
}

export { Shade, IconStyle, IconNames };
